import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '@/store/types';

const initialState = {
  visibility: document.visibilityState === 'visible',
}

const pageState = createSlice({
  name: 'pageState',
  initialState,
  reducers: {
    changeState(state, {payload}: { payload: boolean }) {
      state.visibility = payload
    },
  },
})

export const {changeState} = pageState.actions
export const isVisible = (state: RootState) => state.pageState.visibility
export default pageState.reducer
